module.exports = __webpack_public_path__ + "static/media/art_1040.53fc560a.jpg";